import { render, staticRenderFns } from "./WhatsAppWidget.vue?vue&type=template&id=4935a678&"
import script from "./WhatsAppWidget.vue?vue&type=script&lang=js&"
export * from "./WhatsAppWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports